export const atmManagementcolumnsForExport = [
  // { label: "Name", key: "name" },
  { label: "ATM Name", key: "name" },
  { label: "ATM Code", key: "code" },
  { label: "Bank Name", key: "bankName" },
  { label: "Branch Name", key: "branchName" },
  { label: "City", key: "city" },
  {label: "District", key: "district"},
  { label: "Address", key: "addressLine" },
  // { label: "Address Line 2", key: "addressLine2" },
  { label: "Pin Code", key: "pinCode" },
  {label: "Status", key: "activeStatus"},
  // { label: "Email Address", key: "email" },
  // { label: "Website", key: "website" },
  // { label: "Active Status", key: "activeStatus" },
];